<template>
    <el-dialog :visible.sync="openStatus" class="create-subnet-container"
        :title="$t('subnet.text.create')" :close-on-click-modal="false" v-if="dialogVisible"
        @close="doClose">
        <!-- 地域与可用区 -->
        <el-form class="cps-create-form" style="width: 69%;" label-width="130px" :model="ruleForm" ref="ruleForm"
                :rules="rules">
            <!--地域-->
            <el-form-item :label="$t('create.text.region') | withColon">
                <el-radio-group v-model="ruleForm.selectedRegion">
                    <el-radio-button v-for="(regionName,region,index) in regions" :key="index"
                        :label="region">{{regionName}}
                    </el-radio-button>
                </el-radio-group>
                <el-tooltip effect="dark" class="ml10" placement="right">
                    <div slot="content" class="my-create-tip">{{$t('create.tooltip.region')}}</div>
                    <a><i class="jc-icon-question"></i></a>
                </el-tooltip>
            </el-form-item>
            <!--可用区-->
            <el-form-item :label="$t('create.text.az') | withColon">
                <el-radio-group v-model="ruleForm.selectedZone">
                    <el-radio-button
                        v-for="(azName,az,index) in zones[ruleForm.selectedRegion]" :key="index"
                        :label="az">
                        {{azName}}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <!--私有网络-->
            <el-form-item :label="$t('subnet.text.privateNetwork') | withColon" prop="selectedPrivateNetwork"
                :show-message="false">
                <el-select v-model="ruleForm.selectedPrivateNetwork" class="w350"
                    @visible-change="getAvailableVpcs" @change="getSubnetCountForCurrentVpc">
                    <el-option v-for="item in availablePrivateNetworks" :key="item.vpcId"
                        :label="item.name + '(' + item.vpcId + ')'" :value="item.vpcId"></el-option>
                </el-select>
                <!--以新页签的方式打开创建私有网络页面-->
                <a href="/vpc/list" target="_blank">{{$t('subnet.text.createPrivateNetwork')}}</a>
                <p>{{$t('subnet.help.vpcHasSubnetNo')}}
                    <a href="javascript:void(0)" @click="jumpToVpcDetail(currentVpcObject.vpcName, 'subnet')"
                        v-if="currentVpcObject.subnetCount > 0">
                        {{currentVpcObject.subnetCount}}</a>
                    <span v-else>{{currentVpcObject.subnetCount}}</span>
                    {{$tc('subnet.help.count', currentVpcObject.subnetCount)}}
                </p>
            </el-form-item>
            <!--IPv4 CIDR-->
            <el-form-item
                v-if="ruleForm.selectedPrivateNetwork"
                :label="$t('privateNetwork.segment') | withColon"
                :show-message="false">
                <span>
                    {{vpcIpv4Cidr}}
                </span>
            </el-form-item>
            <!--IPv6 CIDR-->
            <el-form-item
                v-if="ruleForm.selectedPrivateNetwork"
                :label="$t('subnet.text.ipv6Cidr') | withColon"
                :show-message="false">
                <span v-if="vpcIpv6Cidr">
                    {{vpcIpv6Cidr}}
                    <el-tooltip effect="dark" class="ml10" placement="right">
                        <div slot="content" class="my-create-tip">{{$t('subnet.tooltip.vpcIpv6Cidr')}}</div>
                        <a><i class="jc-icon-question"></i></a>
                    </el-tooltip>
                </span>
                <span v-else>
                    <a href="javascript:void(0)" @click="openIpv6">{{$t('subnet.text.openIpv6')}}</a>
                </span>
            </el-form-item>
            <!--名称-->
            <el-form-item
                :label="$t('subnet.text.name') | withColon" prop="name" :show-message="false" required
                ref="name">
                <el-input v-model="ruleForm.name" class="name-input"
                    @blur="ruleFormTag.name=1"
                    @focus="ruleFormTag.name=0"></el-input>
                <p  v-if="ruleFormTag.name!==0 && ruleForm.name==''" class="el-form-item-help-error">
                    {{$t('create.placeholder.nameNull')}}</p>
                <p  v-else class="el-form-item-name-help"
                    :class="{'el-form-item-help-error': this.ruleFormTag.name == 'error'}">
                    {{$t('create.help.name')}}</p>
            </el-form-item>
            <!--主要IPv4 CIDR-->
            <el-form-item :label="$t('subnet.text.cidr') | withColon" required>
                <cidr :cidr-array="[cidr1Val,cidr2Val,cidr3Val,cidr4Val,cidr5Val]"
                    @cidrValsInArray="cidrChange" :create-subnet="true"
                    :subnet-check-failed="subnetCheckFailed" :subnet-check-err-msg="subnetCheckErrMsg"
                    :selected-vpc="ruleForm.selectedPrivateNetwork !== ''"></cidr>
                <el-tooltip effect="dark" class="ml10" placement="right">
                    <div slot="content" class="my-create-tip">{{$t('subnet.help.cidr')}}</div>
                    <a><i class="jc-icon-question"></i></a>
                </el-tooltip>
            </el-form-item>
            <el-form-item>
                <el-tooltip effect="dark" class="add-sub-cidr-button" placement="right"
                    :disabled="!addIconDisabled">
                    <a @click="showSubCidrComponent" :class="{'cps-dropdown-disabled': addIconDisabled }">
                        <i class="jc-icon-plus"></i>
                        {{$t('subnet.text.addSubCidr')}}
                    </a>
                    <div slot="content" class="my-create-tip">{{$t('subnet.help.onlyOneSubCidr')}}</div>
                </el-tooltip>
                <span class="ml10">
                    {{$t('subnet.help.moreAliasIpAvailablePart0')}}
                </span>
                <span class="cps-highlight-font-color">{{remainSubCidrQuantity}}</span>
                <span>
                    {{$t('subnet.help.moreSubCidrPart2')}}
                </span>
            </el-form-item>
            <!--次要CIDR-->
            <el-form-item :label="$t('subnet.text.subCidr') | withColon" v-if="showSubCidr">
                <sub-cidr
                    ref="subCidr"
                    :visible.sync="showSubCidr"
                    @saveSubCidr="subCidrChange" :remainSubCidrQuantity.sync="remainSubCidrQuantity"
                    :addIconDisabled.sync="addIconDisabled"
                    :region="currentRegion"
                    :vpcId="currentVpcObject.vpcId"
                    :cidr="currentSelectedCidr">
                </sub-cidr>
            </el-form-item>
            <!--主要IPv6 CIDR-->
            <el-form-item
                v-if = "vpcIpv6Cidr"
                :label="$t('subnet.text.primaryIpv6Cidr') | withColon" required>
                <ipv6-cidr
                    :cidr-array="[ipv6Cidr1Val,ipv6Cidr2Val,ipv6Cidr3Val]"
                    @ipv6CidrVal="ipv6CidrChange"
                ></ipv6-cidr>
            </el-form-item>
            <!--描述-->
            <el-form-item :label="$t('create.text.desc') | withColon" prop="desc" :show-message="false" ref="desc">
                <el-input type="textarea" :rows="4" class="desc-input" v-model="ruleForm.desc"></el-input>
                <p class="el-form-item-name-help"
                    :class="{'el-form-item-help-error': this.ruleFormTag.desc == 'error'}">
                    {{$t('create.help.desc')}}</p>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
            <el-button @click="doConfirm" type="primary">{{ $t('detail.text.sure') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { NetworkTypeConstant } from '@/common/Constants';
import cidr from '@/components/common/cidr/Cidr';
import SubCidr from '@/components/subnet/subCidr/SubCidr';
import ipv6Cidr from '@/components/subnet/ipv6Cidr/Ipv6Cidr';
import ipv6Private from '@/components/privateNetwork/ipv6Private/ipv6Private';

const validateLength = (rule, value, callback) => {
    if (value.length > 256) {
        callback(new Error());
    } else {
        callback();
    }
};
export default {
    components: {
        cidr,
        SubCidr,
        ipv6Cidr,
        ipv6Private
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: true,
        },
        currentRegion: {
            type: String,
            default: ''
        },
        hasEnableVpcIpv6: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            openStatus: this.dialogVisible,
            ruleForm: {
                selectedRegion: this.currentRegion,
                selectedZone: '',
                selectedPrivateNetwork: '',
                routeMap: 'default', // 路由表
                name: '',
                selectedCidr: '*.*.*.*/*',
                desc: '',
            },
            ruleFormTag: {
                name: 0,
                desc: 0,
            },
            // vpc ipv4Cidr
            vpcIpv4Cidr: '',
            // vpc ipv6Cidr
            vpcIpv6Cidr: '',
            cidr1Val: 10,
            cidr2Val: 0,
            cidr3Val: 0,
            cidr4Val: 0,
            cidr5Val: 16,
            ipv6Cidr1Val: '',
            ipv6Cidr2Val: '0',
            ipv6Cidr3Val: '',
            regions: {},
            zones: { '': {} },
            availablePrivateNetworks: [],
            rules: {
                name: [
                    {
                        type: 'string',
                        pattern: new RegExp('^[-0-9a-zA-Z_\\u4e00-\\u9fa5]{1,32}$'),
                        trigger: 'blur'
                    }
                ],
                desc: [
                    { type: 'string', validator: validateLength, trigger: 'blur' }
                ],
                selectedPrivateNetwork: [
                    { required: true, trigger: 'blur', type: 'string' }
                ]
            },
            // 当前选择的VPC对象
            currentVpcObject: {
                subnetCount: 0
            },
            // 所有VPC的详情数组
            dataOfAllVpc: [],
            // 子网是否不符合校验
            subnetCheckFailed: false,
            // 子网不符合校验错误提示
            subnetCheckErrMsg: '',
            // 获得对应region下的zone
            zonesUnderRegion: {},
            ipv6PrivateShow: false,
            isLegalIpv6Cidr: false,
            // 是否添加次要CIDR
            showSubCidr: false,
            // 可添加的次要CIDR数量
            remainSubCidrQuantity: 1,
            showOneSubCidr: false,
            subCidr: {
                secondaryCidr: '',
                secondaryCidrName: ''
            },
            addIconDisabled: false,
        };
    },
    computed: {
        currentSelectedRegion() {
            return this.ruleForm.selectedRegion;
        },
        currentSelectedCidr() {
            return `${this.cidr1Val}.${this.cidr2Val}.${this.cidr3Val}.${this.cidr4Val
            }/${this.cidr5Val}`;
        }
    },
    watch: {
        dialogVisible(val) {
            this.openStatus = val;
        },
        currentRegion(val){
            this.ruleForm.selectedRegion = val
            if (this.zones[val]) {
                for (var az in this.zones[this.selectedRegion]) {
                    this.ruleForm.selectedZone = az
                    break
                }
            } else {
                this.ruleForm.selectedZone = ''
            }
        },
        currentSelectedRegion(newValue) {
            if (newValue) {
                if (this.zones[this.ruleForm.selectedRegion]) {
                    for (const az in this.zones[this.ruleForm.selectedRegion]) {
                        this.ruleForm.selectedZone = az;
                        break;
                    }
                } else {
                    this.ruleForm.selectedZone = '';
                }
                this.getAvailableVpcs();
                // 清空已选的VPC
                this.ruleForm.selectedPrivateNetwork = '';
                this.currentVpcObject.subnetCount = 0;
            }
        },
        hasEnableVpcIpv6() {
            this.ruleForm.selectedPrivateNetwork = '';
            this.currentVpcObject.subnetCount = 0;
        }
    },
    created() {
        this.getRegions();
    },
    methods: {
        // 关闭弹框
        doClose() {
            //this.doReset('ruleForm');
            this.$emit('ifDialogVisible', false);
            // this.currentVpcObject.subnetCount = 0;
            // this.subnetCheckFailed = false;
            // this.subnetCheckErrMsg = '';
            // this.restSubCidrInfo();
        },
        // 点击确认按钮
        doConfirm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.checkSubnets();
                }
            });
        },
        // 清空表单
        doReset(formName) {
            this.$refs[formName].resetFields();
            this.cidr1Val = 10;
            this.cidr2Val = 0;
            this.cidr3Val = 0;
            this.cidr4Val = 0;
            this.cidr5Val = 16;
            this.ruleFormTag.name = 0;
        },
        // 取地域和可用区
        getRegions() {
          Ajax.get({
            action: '/getRegions',
            param: {
              networkType: NetworkTypeConstant.VPC
            },
            success: (data) => {
              for (const i in data.regions) {
                const region = data.regions[i].region;
                const regionName = data.regions[i].regionName;
                const zones = data.regions[i].azs;
                this.zonesUnderRegion[region] = zones;
                this.regions[region] = regionName;
                for (const j in zones) {
                  const az = zones[j].az;
                  const azName = zones[j].azName;
                  if (typeof this.zones[region] === 'undefined') {
                    this.zones[region] = {};
                  }
                  this.zones[region][az] = azName;
                }
              }
              const passedRegion = this.currentRegion;
              if (passedRegion != undefined) {
                this.ruleForm.selectedRegion = passedRegion;
              } else {
                this.ruleForm.selectedRegion = data.regions[0].region;
              }
              this.ruleForm.selectedZone = this.zonesUnderRegion[this.ruleForm.selectedRegion][0].az;
            }
          });
        },
        // 获取当前区域下的可用私有网络
        getAvailableVpcs() {
          Ajax.get({
            action: '/listVpcs',
            param: {
              region: this.ruleForm.selectedRegion,
              pageSize: 100
            },
            success: (data) => {
              this.availablePrivateNetworks = data.vpcs;
              for (const item of this.availablePrivateNetworks) {
                const object = {
                  key: item.vpcId,
                  value: item
                };
                this.dataOfAllVpc.push(object);
              }
            }
          });
        },
        // 获得当前vpc下子网个数
        getSubnetCountForCurrentVpc() {
            this.ruleForm.ipv6Cidr = '';
            this.ruleForm.lastIpv6Cidr = '';
            // 切换私有网络后，初始化CIDR相关数据
            this.cidr1Val = 10;
            this.cidr2Val = 0;
            this.cidr3Val = 0;
            this.cidr4Val = 0;
            this.cidr5Val = 16;

            for (const item of this.dataOfAllVpc) {
                if (item.key === this.ruleForm.selectedPrivateNetwork) {
                    this.currentVpcObject = item.value;
                    this.cidr1Val = this.currentVpcObject.cidr.split('.')[0];
                    this.cidr2Val = this.currentVpcObject.cidr.split('.')[1];
                    this.cidr3Val = 0
                    this.cidr5Val = this.currentVpcObject.cidr.split('/')[1];
                    this.vpcIpv4Cidr = this.currentVpcObject.cidr;
                    this.vpcIpv6Cidr = this.currentVpcObject.ipv6Cidr;
                    if (this.vpcIpv6Cidr) {
                        let ipv6Cidr1 = this.vpcIpv6Cidr.split('::')[0];
                        this.ipv6Cidr1Val = ipv6Cidr1.substr(0,ipv6Cidr1.length-1);
                        this.ipv6Cidr2Val = '0';
                        this.ipv6Cidr3Val = 64;
                    }
                }
            }
        },
        // 调用创建子网接口
        createSubnet(params) {
            if (!this.isLegalIpv6Cidr && this.vpcIpv6Cidr && this.ipv6Cidr2Val !=='0') {
                return;
            }
            Ajax.put('/api/cps/subnets', params)
            .then(() => {
                this.$emit('refreshList');
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.doClose();
            });
        },
        cidrChange(cidrValsInArray) {
            [this.cidr1Val, this.cidr2Val, this.cidr3Val, this.cidr4Val, this.cidr5Val] = cidrValsInArray;
        },

        ipv6CidrChange(ipv6CidrArray) {
            [this.ipv6Cidr1Val, this.ipv6Cidr2Val,this.ipv6Cidr3Val,this.isLegalIpv6Cidr] = ipv6CidrArray
        },
        // 跳转到VPC详情页
        jumpToVpcDetail(vpcName, tabName) {
            if (this.currentVpcObject.subnetCount === 0) {
                return false;
            }
            this.$router.push({
                path: '/vpc/detail',
                query: {
                    region: this.currentVpcObject.region,
                    vpcName,
                    tabName,
                    id: this.currentVpcObject.vpcId
                }
            });
        },
        /**
           **@disc:检测子网是否在对应VPC可选范围内
           **@params:region, vpc cidr
           */
        checkSubnets() {
            this.subnetCheckFailed = false
            const params = {
                region: this.ruleForm.selectedRegion,
                cidr: this.currentSelectedCidr,
                vpcId: this.currentVpcObject.vpcId
            };
            Ajax.get('/api/cps/checkSubnets', params)
            .then((res) => {
                const params = {
                    region: this.ruleForm.selectedRegion,
                    az: this.ruleForm.selectedZone,
                    vpcId: this.ruleForm.selectedPrivateNetwork,
                    cidr: this.currentSelectedCidr,
                    name: this.ruleForm.name,
                    description: this.ruleForm.desc,
                    secondaryCidr: this.subCidr.secondaryCidr,
                    secondaryCidrName: this.subCidr.secondaryCidrName,
                    clientToken: Normal.getClientToken(),
                };
                if (this.vpcIpv6Cidr) {
                    params.ipv6Cidr = this.ipv6Cidr1Val + this.ipv6Cidr2Val + "::/" + this.ipv6Cidr3Val;
                }
                // 调用创建子网的接口
                this.createSubnet(params);
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    if (json.errno === 10165) {
                        this.subnetCheckFailed = true;
                        this.subnetCheckErrMsg = json.errmsg;
                    }
                    if (this.subnetCheckFailed) {
                        return false;
                    }
                    console.log(json);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
            });
        },

        openIpv6(row) {
            let currentVpcObject = this.currentVpcObject
            this.$emit('showIpv6Private', currentVpcObject);
            this.ipv6PrivateShow = true;
        },

        // 显示添加次要CIDR组件
        showSubCidrComponent() {
            if(this.showSubCidr) {
                return
            }
            this.showSubCidr = true;
            this.addIconDisabled = true;
            this.remainSubCidrQuantity--;
        },

        // 添加次要CIDR后保存
        subCidrChange(subCidrInfo) {
            this.subCidr = subCidrInfo
        },

        // 重置次要CiDR相关依赖数据
        restSubCidrInfo() {
            this.subCidr = {
                secondaryCidr: '',
                secondaryCidrName: ''
            };
            if (this.$refs.subCidr) {
                this.$refs.subCidr.deleteSubCidr();
            }
        },
    }
};
</script>

<style lang="scss">
    @import '../../../assets/scss/createCommon';
    @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/subnet/create/Create.vue